import { DisbursementTypeEnum } from '../../constants'

const objFunc = () => {
  return {
    applicationId: '',
    appraisalId: '',
    collateral: '', // formatted like '2022 Toyota Camry'
    customerId: '',
    disbursementAmount: 0,
    disbursementOptions: {
      isDebitDisbursementAvailable: false,
      isMoneyGramDisbursementAvailable: false,
      isStoreDisbursementAvailable: false
    },
    disbursementType: DisbursementTypeEnum.none,
    dueDate: '', // formatted like '2024-09-28T00:00:00-05:00'
    loanAmount: 0,
    loanId: '',
    loanStatusId: '',
    loanTypeCode: '',
    locationId: 0, // MMStoreId
    locationBrand: '', // MMStoreType
    storeId: 0,
    maxLoanAmount: 0,
    minLoanAmount: 0,
    originationKey: '',
    productId: 0
  }
}

export default objFunc()

export const defaultObj = objFunc()
